// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__C79hX","right":"styles_right__1owZQ"};